<template>
  <admin-wrapper
    ref="form"
    :straight-title="additionalModuleName"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    :inputs="inputs"
    @save="save"
  >
    <template #treeview.input="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="params.settings.tree_view_id" @change="onTreeviewChange" />
      </v-col>
    </template>
    <template #numberAttribute.input="data">
      <v-col cols="3">
        <data-input
          v-bind="data"
          v-model="params.settings.street_lamp_number_attribute"
          @change="paramsChanged = true"
        />
      </v-col>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';

export default {
  name: 'StreetLampInventorySettings',
  components: { AdminWrapper, DataInput },
  computed: {
    additionalModuleName: get('admin/additionalModules@ILS_SESSIONS_MODULE.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@street_lamp_inventory_module_enabled'),
    moduleEnabler() {
      return {
        name: 'street_lamp_inventory_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle2', { suffix: this.additionalModuleName }),
      };
    },
    treeviews: get('attributesSchema/treeviews'),
    mappedTreeviews() {
      return this.treeviews.map(treeview => {
        return { value: treeview.id, text: treeview.name };
      });
    },
    dataSourceSettingsName() {
      return 'ils_street_lamp_datasource';
    },
    dataSources: get('layers/metadata'),
    selectedDatasourceAttributes() {
      return (
        this.dataSources[this.params.datasource]?.attributes_schema.attributes?.filter(
          attr => attr.data_type.name === 'text'
        ) || []
      );
    },
    inputs() {
      return [
        {
          name: 'treeview',
          translationPath: 'admin.streetLampInventory.treeview',
          subtitle: this.$i18n.t('admin.streetLampInventory.treeviewSubtitle'),
          dataType: {
            name: 'select',
          },
          items: this.mappedTreeviews,
        },
        {
          name: 'numberAttribute',
          translationPath: 'admin.streetLampInventory.lampNumberAttribute',
          dataType: {
            name: 'select',
          },
          items: this.selectedDatasourceAttributes,
          itemText: 'verbose_name',
          itemValue: 'name',
        },
      ];
    },
  },
  data: () => ({
    isFormFetched: false,
    paramsChanged: false,
    params: {
      settings: {
        tree_view_id: null,
        street_lamp_number_attribute: '',
      },
      datasource: '',
    },
  }),
  methods: {
    editDatasourceSettings: call('datasourceSettings/editDatasourceSettings'),
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    getDataSources: call('layers/getLayersMetadata'),
    getTreeviews: call('attributesSchema/getTreeviews'),
    onTreeviewChange(value) {
      this.params.datasource = this.treeviews.find(tv => tv.id === value)?.datasource || '';
      this.params.settings.street_lamp_number_attribute = '';
      this.paramsChanged = true;
    },
    async save() {
      if (!this.paramsChanged) return;
      const payload = { name: this.dataSourceSettingsName, settings: this.params };
      await this.editDatasourceSettings(payload);
      this.paramsChanged = false;
      this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
        message: this.$i18n.t('success.successEditSetting'),
      });
    },
    async updateSelectedDataSource() {
      try {
        const r = await this.getDatasourceSettings(this.dataSourceSettingsName);
        const { datasource, settings } = r;
        this.params = { datasource, settings };
        this.paramsChanged = false;
      } catch {
        this.systemProviderProps = {
          settings: {
            tree_view_id: null,
            street_lamp_number_attribute: '',
          },
          datasource: '',
        };
        this.paramsChanged = false;
      }
    },
    async init() {
      await Promise.all([this.getDataSources({ with_attributes_schema: true }), this.getTreeviews()]);
      await this.updateSelectedDataSource();
      this.isFormFetched = true;
      this.$nextTick(() => {
        this.$refs.form?.$refs.form?.$refs.form?.resetValidation();
      });
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
